// Generated by CoffeeScript 2.4.1
(function() {
  var AttributeDefinition, ErrorCodes, GET, ModelContext, POST, Promise, RelationDefinition, Weaver, WeaverError, WeaverModel, _,
    indexOf = [].indexOf;

  Promise = require('bluebird');

  _ = require('lodash');

  Weaver = require('./Weaver');

  ModelContext = require('./WeaverModelContext');

  WeaverError = require('./Error');

  ErrorCodes = require('./WeaverError');

  GET = Weaver.GET;

  POST = Weaver.POST;

  AttributeDefinition = class AttributeDefinition {
    constructor(key, definition) {
      this.modelKey = key;
      this.key = definition != null ? definition.key : void 0;
      this.datatype = definition != null ? definition.datatype : void 0; // todo: move to dataType
      this.required = definition != null ? definition.required : void 0;
    }

  };

  RelationDefinition = class RelationDefinition {
    constructor(key, definition) {
      this.modelKey = key;
      this.key = definition != null ? definition.key : void 0;
      this.range = definition != null ? definition.range : void 0;
      this.card = definition != null ? definition.card : void 0;
    }

  };

  WeaverModel = class WeaverModel extends ModelContext {
    constructor(definition) {
      super(definition);
    }

    async init() {
      var classDefinition, classId, className, classObj, context, i, incl, itemName, len, modelTag, node, nodeId, prefix, ref, ref1, ref10, ref11, ref12, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, superClassId, tag;
      // Map classId to ModelClass
      this.classList = {};
      // Maps 'model-name@version' to the context object
      this.contextMap = {};
      this.contextMap[`${this.definition.name}@${this.definition.version}`] = this;
      this.loadMap = {};
      this.loadMap[this.definition.name] = this.definition.version;
      // Deprecated
      this.modelMap = {};
      this.modelMap[this.definition.name] = this;
      this.includes = {};
      await this._loadIncludes(this.definition);
      ref = this.contextMap;
      // Bring model to life
      for (modelTag in ref) {
        context = ref[modelTag];
        ref1 = context.definition.modelPrefixes;
        for (prefix in ref1) {
          incl = ref1[prefix];
          context[prefix] = this.contextMap[incl.tag];
        }
      }
      ref2 = this.contextMap;
      for (modelTag in ref2) {
        context = ref2[modelTag];
        ref3 = context.definition.classes;
        for (className in ref3) {
          classDefinition = ref3[className];
          if (context.isNativeClass(className)) {
            this._registerClass(context, className, classDefinition);
          }
        }
      }
      ref4 = this.contextMap;
      for (modelTag in ref4) {
        context = ref4[modelTag];
        ref5 = context.definition.classes;
        for (className in ref5) {
          classDefinition = ref5[className];
          if ((classDefinition != null ? classDefinition.super : void 0) != null) {
            classId = context.getNodeNameByKey(className);
            superClassId = context.getNodeNameByKey(classDefinition.super);
            this.classList[superClassId].subClasses.push(classId);
          }
        }
      }
      ref6 = this.contextMap;
      for (modelTag in ref6) {
        context = ref6[modelTag];
        ref7 = context.definition.classes;
        for (className in ref7) {
          classDefinition = ref7[className];
          if (context.isNativeClass(className)) {
            context[className].totalClassDefinition = this._collectFromSupers(classDefinition, context);
          }
        }
      }
      ref8 = this.contextMap;
      for (modelTag in ref8) {
        context = ref8[modelTag];
        ref9 = context.definition.classes;
        for (className in ref9) {
          classDefinition = ref9[className];
          if (context.isNativeClass(className)) {
            context[className].totalRangesMap = this._buildRanges(context[className].totalClassDefinition, context);
          }
        }
      }
      ref10 = this.contextMap;
      for (tag in ref10) {
        context = ref10[tag];
        ref11 = context.definition.classes;
        for (className in ref11) {
          classObj = ref11[className];
          if ((classObj != null ? classObj.init : void 0) != null) {
            ref12 = classObj.init;
            for (i = 0, len = ref12.length; i < len; i++) {
              itemName = ref12[i];
              nodeId = itemName.indexOf(':') === -1 ? `${context.definition.name}:${itemName}` : `${itemName}`;
              node = new context[className](nodeId, context.getGraph(), this);
              node._pendingWrites = [];
              node.nodeRelation(this.getMemberKey)._pendingWrites = [];
              context[className][itemName] = node;
            }
          }
        }
      }
      return this;
    }

    _registerClass(context, className, classDefinition) {
      var cleanClassName, js, load, modelClass;
      cleanClassName = className.replace(/[^0-9A-Za-z]/g, '').replace(/[$0-9]*/, '');
      js = new Function('Weaver', `return class ${cleanClassName} extends Weaver.ModelClass {\n  constructor(nodeId, graph) {\n    super(nodeId, graph, ${cleanClassName}.model);\n\n    // Reflect class fields inward to instance\n    this.className            = "${className}";\n    this.model                = ${cleanClassName}.model;\n    this.context              = ${cleanClassName}.context;\n    this.definition           = ${cleanClassName}.definition;\n    this.classDefinition      = ${cleanClassName}.classDefinition;\n    this.totalClassDefinition = ${cleanClassName}.totalClassDefinition;\n    this.totalRangesMap       = ${cleanClassName}.totalRangesMap;\n  }\n}`);
      modelClass = js(Weaver);
      modelClass.className = className;
      modelClass.model = this;
      modelClass.context = context;
      modelClass.definition = this.definition;
      modelClass.classDefinition = classDefinition;
      modelClass.classId = function() {
        return this.context.getNodeNameByKey(this.className);
      };
      modelClass.subClasses = [];
      // Also undefind is a valid as agrument for graph
      load = (loadClass) => {
        return (nodeId, graph) => {
          var query;
          query = new Weaver.ModelQuery(this).class(context[loadClass]).restrict(nodeId);
          if (arguments.length > 1) { // consult function header
            query.restrictGraphs([graph]);
          }
          return query.first(context[loadClass]);
        };
      };
      modelClass.load = load(className);
      modelClass.loadFromGraph = load(className);
      context[className] = modelClass;
      return this.classList[modelClass.classId()] = modelClass;
    }

    // Recurs over all definitions filling the contextMap
    _loadIncludes(definition) {
      var inc, key, obj, ref;
      if (definition.includes == null) {
        return Promise.resolve();
      }
      // Add map with local prefix to contextMap key
      definition.modelPrefixes = {};
      ref = definition.includes;
      for (key in ref) {
        obj = ref[key];
        definition.modelPrefixes[key] = {
          prefix: key,
          name: obj.name,
          version: obj.version,
          tag: `${obj.name}@${obj.version}`
        };
      }
      // Depth first to prevent concurrent version checks
      return Promise.mapSeries((function() {
        var ref1, results;
        ref1 = definition.modelPrefixes;
        results = [];
        for (key in ref1) {
          inc = ref1[key];
          results.push(inc);
        }
        return results;
      })(), async(obj) => {
        var context, includedModel;
        if (this.loadMap[obj.name] != null) {
          if (this.loadMap[obj.name] !== obj.version) {
            throw WeaverError(ErrorCodes.MODEL_INCLUSION_CYCLE, `Model ${this.definition.name} tries to include ${obj.name} but this introduces a cycle`);
          } else {
            // Definition is already loaded
            return Promise.resolve();
          }
        }
        this.loadMap[obj.name] = obj.version;
        this.modelMap[obj.name] = this; // Deprecated, set for backbward compatibility
        includedModel = (await WeaverModel._loadDefinition(obj.name, obj.version));
        context = new ModelContext(includedModel.definition, this);
        this.contextMap[obj.tag] = context;
        this.includes[obj.prefix] = context; // Deprecated, set for backbward compatibility
        return this._loadIncludes(includedModel.definition);
      });
    }

    _collectFromSupers(classDefinition, context) {
      var addFromSuper;
      addFromSuper = (cd, context, definition = this.definition, totalDefinition = {
          attributes: {},
          relations: {},
          label: void 0
        }) => {
        var superClassId, superDefinition, transfer;
        // Start with supers so lower specifications override the super ones
        if ((cd != null ? cd.super : void 0) != null) {
          superClassId = context.getNodeNameByKey(cd.super);
          superDefinition = this.classList[superClassId].classDefinition;
          addFromSuper(superDefinition, this.classList[superClassId].context, definition, totalDefinition);
        }
        transfer = (source, defConstructor) => {
          var i, key, len, range, ranges, ref, results, updated, updatedRanges, v;
          ref = cd != null ? cd[source] : void 0;
          results = [];
          for (key in ref) {
            v = ref[key];
            if ((cd != null ? cd[source] : void 0) != null) {
              totalDefinition[source][key] = new defConstructor(key, v);
              if ((v != null ? v.range : void 0) != null) {
                updatedRanges = [];
                ranges = v.range;
                if (!_.isArray(ranges)) {
                  ranges = _.keys(ranges);
                }
                for (i = 0, len = ranges.length; i < len; i++) {
                  range = ranges[i];
                  updated = context.getNodeNameByKey(range);
                  updatedRanges.push(updated);
                }
                results.push(totalDefinition[source][key].range = updatedRanges);
              } else {
                results.push(void 0);
              }
            } else {
              results.push(void 0);
            }
          }
          return results;
        };
        transfer('attributes', AttributeDefinition);
        transfer('relations', RelationDefinition);
        if ((cd != null ? cd['label'] : void 0) != null) {
          totalDefinition['label'] = cd['label'];
        }
        return totalDefinition;
      };
      return addFromSuper(classDefinition, context);
    }

    _buildRanges(totalClassDefinition, context) {
      var key, map, obj, ref;
      map = {};
      ref = totalClassDefinition.relations;
      for (key in ref) {
        obj = ref[key];
        map[key] = this._getRanges(key, totalClassDefinition, context);
      }
      return map;
    }

    _getRanges(key, totalClassDefinition, context) {
      var i, len, rangeClass, rangeId, ref, totalRanges;
      totalRanges = [];
      ref = this._getRangeKeys(key, totalClassDefinition);
      for (i = 0, len = ref.length; i < len; i++) {
        rangeId = ref[i];
        rangeClass = this.classList[rangeId];
        totalRanges = _.union(totalRanges, [rangeId], rangeClass.allSubClasses());
      }
      return totalRanges;
    }

    _getRangeKeys(key, totalClassDefinition) {
      var i, len, range, ranges, ref, results;
      if (totalClassDefinition.relations == null) {
        return [];
      }
      ranges = ((ref = totalClassDefinition.relations[key]) != null ? ref.range : void 0) || [];
      if (!_.isArray(ranges)) {
        ranges = _.keys(ranges);
      }
      results = [];
      for (i = 0, len = ranges.length; i < len; i++) {
        range = ranges[i];
        results.push(range);
      }
      return results;
    }

    addSupers(ids, total = []) {
      var context, definition, i, id, len, node, superId;
      for (i = 0, len = ids.length; i < len; i++) {
        id = ids[i];
        if (indexOf.call(total, id) < 0) {
          total.push(id);
        }
        node = this.classList[id];
        if (node != null) {
          context = node.context;
          definition = node.classDefinition;
          if ((definition != null ? definition.super : void 0) != null) {
            superId = context.getNodeNameByKey(definition.super);
            if (indexOf.call(total, superId) < 0) {
              this.addSupers([superId], total);
            }
          }
        }
      }
      return total;
    }

    getGraphName() {
      console.warn('Deprecated function WeaverModel.getGraphName() used. Use WeaverModelContext.getGraph().');
      return this.getGraph();
    }

    getClassName(classId) {
      var ref;
      return (ref = this.classList[classId]) != null ? ref.className : void 0;
    }

    // Load given model from server
    static async _loadDefinition(name, version) {
      var definition;
      definition = (await POST("model.read", {name, version}));
      return new Weaver.Model(definition);
    }

    static async load(name, version, includeList) {
      var model;
      model = (await WeaverModel._loadDefinition(name, version));
      return model.init(includeList);
    }

    static async reload(name, version, includeList) {
      var definition, model;
      definition = (await POST("model.reload", {name, version}));
      model = (await new Weaver.Model(definition));
      return model.init(includeList);
    }

    static list() {
      return GET("model.list");
    }

    getInheritKey() {
      return this.definition.inherit || '_inherit';
    }

    getMemberKey() {
      return this.definition.member || '_member';
    }

    getPrototypeKey() {
      console.warn('Deprecated function WeaverModel.getPrototypeKey() used. Use WeaverModel.getMemberKey().');
      return this.getMemberKey();
    }

    async bootstrap(project, branch) {
      var context, existingNodes, tag;
      existingNodes = {};
      await Promise.map((function() {
        var ref, results;
        ref = this.contextMap;
        results = [];
        for (tag in ref) {
          context = ref[tag];
          results.push(context);
        }
        return results;
      }).call(this), async(context) => {
        var i, len, n, nodes, results;
        nodes = (await new Weaver.Query(project, branch).restrictGraphs(context.getGraph()).unlimited());
        results = [];
        for (i = 0, len = nodes.length; i < len; i++) {
          n = nodes[i];
          results.push(existingNodes[n.id()] = n);
        }
        return results;
      });
      return this._bootstrapClasses(existingNodes, void 0, project, branch);
    }

    async _bootstrapClasses(existingNodes, nodesToCreate = {}, project, branch) {
      var classes, context, contexts, firstOrCreate, i, inheritKey, inheritenceLinks, initLinks, j, k, len, len1, len2, memberKey, model, tag, writes;
      firstOrCreate = function(id, graph, NodeClass = Weaver.Node, create = true, writes) {
        var node;
        if (nodesToCreate[id] != null) {
          return nodesToCreate[id];
        }
        if (existingNodes[id] != null) {
          node = existingNodes[id];
          nodesToCreate[id] = node;
          return node;
        }
        if (!create) {
          throw new Error(`Node ${id} in graph ${graph} should already exist in this phase of bootstrapping`);
        }
        node = new NodeClass(id, graph);
        Weaver.Functions.popWrites(node, writes);
        return nodesToCreate[id] = node;
      };
      initLinks = function(context, model, memberkey, writes) {
        var className, classNames, classObj, i, itemName, len, node, nodeId, owner, ownerId, results;
        classNames = (function() {
          var ref, results;
          ref = context.definition.classes;
          results = [];
          for (className in ref) {
            classObj = ref[className];
            if ((classObj != null ? classObj.init : void 0) != null) {
              results.push(className);
            }
          }
          return results;
        })();
        results = [];
        for (i = 0, len = classNames.length; i < len; i++) {
          className = classNames[i];
          classObj = context.definition.classes[className];
          ownerId = context.getNodeNameByKey(className);
          owner = firstOrCreate(ownerId, context.getGraph(), void 0, void 0, writes);
          results.push((function() {
            var j, len1, ref, results1;
            ref = classObj.init;
            results1 = [];
            for (j = 0, len1 = ref.length; j < len1; j++) {
              itemName = ref[j];
              nodeId = itemName.indexOf(':') === -1 ? `${context.definition.name}:${itemName}` : `${itemName}`;
              node = firstOrCreate(nodeId, context.getGraph(), Weaver.DefinedNode, void 0, writes);
              node.model = model;
              node.relation(memberKey).add(owner, {
                upsert: true
              });
              results1.push(Weaver.Functions.popWrites(node.relation(memberKey), writes));
            }
            return results1;
          })());
        }
        return results;
      };
      classes = function(context, writes) {
        var className, classNames, classObj, i, id, len, results;
        classNames = (function() {
          var ref, results;
          ref = context.definition.classes;
          results = [];
          for (className in ref) {
            classObj = ref[className];
            results.push(className);
          }
          return results;
        })();
        results = [];
        for (i = 0, len = classNames.length; i < len; i++) {
          className = classNames[i];
          id = context.getNodeNameByKey(className);
          results.push(firstOrCreate(id, context.getGraph(), void 0, void 0, writes));
        }
        return results;
      };
      inheritenceLinks = function(context, inheritKey, writes) {
        var className, classNames, classObj, i, id, len, node, results, superId, superNode;
        classNames = (function() {
          var ref, results;
          ref = context.definition.classes;
          results = [];
          for (className in ref) {
            classObj = ref[className];
            if ((classObj != null ? classObj.super : void 0) != null) {
              results.push(className);
            }
          }
          return results;
        })();
        results = [];
        for (i = 0, len = classNames.length; i < len; i++) {
          className = classNames[i];
          classObj = context.definition.classes[className];
          id = context.getNodeNameByKey(className);
          superId = context.getNodeNameByKey(classObj.super);
          node = firstOrCreate(id, context.getGraph(), void 0, void 0, writes);
          superNode = firstOrCreate(superId, context.getGraph(), void 0, false, writes);
          node.relation(inheritKey).add(superNode, {
            upsert: true
          });
          results.push(Weaver.Functions.popWrites(node.relation(inheritKey), writes));
        }
        return results;
      };
      // First create all class instances
      model = this.model;
      memberKey = this.getMemberKey();
      inheritKey = this.getInheritKey();
      contexts = (function() {
        var ref, results;
        ref = this.contextMap;
        results = [];
        for (tag in ref) {
          context = ref[tag];
          results.push(context);
        }
        return results;
      }).call(this);
      writes = [];
      for (i = 0, len = contexts.length; i < len; i++) {
        context = contexts[i];
        initLinks(context, model, memberKey, writes);
      }
      for (j = 0, len1 = contexts.length; j < len1; j++) {
        context = contexts[j];
        classes(context, writes);
      }
      for (k = 0, len2 = contexts.length; k < len2; k++) {
        context = contexts[k];
        inheritenceLinks(context, inheritKey, writes);
      }
      return (await Weaver.Functions.executeWrites(writes, void 0, {project, branch}));
    }

  };

  module.exports = WeaverModel;

}).call(this);
